import React from 'react';

export const name = 'send';

export const Send = () => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.59 16H7.06004L4.41003 20.68"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M20.2501 8.66016L27.5901 16.0002L20.2501 23.3402"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
